// extracted by mini-css-extract-plugin
export default {"fitSize":"fit-size_fitSize__N3NSG","fitSizeInner":"fit-size_fitSizeInner__UVh9E","not_verticel":"fit-size_not_verticel__6mAjQ","verticel":"fit-size_verticel__GXP5X"};